import axios from "axios";
import apiUrl from "../apiUrl";

export const cancelOrder = (orderId, token) => {
  return axios
    .post(
      `${apiUrl}/order/cancel`,
      { orderId },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
